import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { seoActivitySegmentationListingPage_seoSegmentationActivityDetails_SEOSegmentationActivityDetailsSuccess_segmentDetails as SEOSegmentationActivityDetailsSuccessType } from '@/__generated__/seoActivitySegmentationListingPage';
import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { UI_FEATURE_FLAGS } from '@/constants';
import { SortByDropdown } from './SortByDropdown';

export interface ExploreHeaderTextProps {
  hasResults: boolean;
  headline: SEOSegmentationActivityDetailsSuccessType['headline'];
}

export const ExploreHeaderText: FC<ExploreHeaderTextProps> = ({ headline, hasResults }) => {
  const directorySortFlag = useFeatureFlag(UI_FEATURE_FLAGS.OHPN_DIRECTORY_SORT_BY.id);
  const isDirectorySortEnabled = Boolean(directorySortFlag?.value);

  if (isDirectorySortEnabled) {
    return (
      <Stack
        mb={{ xs: 2, sm: 3 }}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
        gap={2}>
        <Typography typography={{ xs: 'h2', md: 'h1' }} component="h1">
          {headline}
        </Typography>

        {hasResults && <SortByDropdown />}
      </Stack>
    );
  }

  return (
    <Box my={{ xs: 1, sm: 2 }} mb={{ xs: 2 }} mt={{ xs: 2 }}>
      <Typography component="h1" typography={{ xs: 'h2', md: 'h1' }}>
        {headline}
      </Typography>
    </Box>
  );
};
